import smsConfigurationStyle from "../sms-configuration.module.css";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactDOMServer from "react-dom/server";
import { Table } from "react-bootstrap";
import { cloneDeep } from "lodash";

// Const
import { organizationType } from "const/nuclias/organization";

// Component
import ButtonAction from "components/ButtonAction";
import EditableNameBox from "components/EditableNameBox";
import TooltipDialogFixed from "components/TooltipDialogFixed";

// Controller
import controller from "../controller";

const SmsConfigurationTable = (props) => {
  const {
    tableRef,
    stickyStyle,
    tableHeader,
    selectedPage,
    selectedPageLimit,
    currentSmsConfigList,
    modalStatus,
    changeModalStatus,
    selectedOrg,
    selectSmsConfigCallback,
    handleDelete,
    successCallback,
    errorCallback
  } = props;

  const { t } = useTranslation();

  // State
  const [originList, setOriginList] = useState([]);

  // Method
  const showAccessLevel = (smsConfig) => {
    const accessLevelTooltipContent = (managedSiteList) => {
      return (
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>{t('a7d6475ec8')}</th>
            </tr>
          </thead>
          <tbody>
            {managedSiteList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.site}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      );
    };

    if (smsConfig.accessLevelType === organizationType.org) {
      return t(smsConfig.accessLevelLabel);
    }

    if (smsConfig.accessLevelType === organizationType.tag) {
      return (
        <>
          {t(smsConfig.accessLevelLabel)}
          &nbsp;(&nbsp;
          <TooltipDialogFixed
            className="ms-1 me-1"
            placement="right"
            title={ReactDOMServer.renderToString(accessLevelTooltipContent(smsConfig.managedSiteList))}
            hideIcon={true}
            tooltipsTitle={smsConfig.managedSiteTag}
          />
          &nbsp;)
        </>
      )
    }

    if (smsConfig.accessLevelType === organizationType.site) {
      return (
        <>
          {t(smsConfig.accessLevelLabel)}
          &nbsp;(&nbsp;
          {smsConfig.managedSite}
          &nbsp;)
        </>
      )
    }
  }

  const changeName = (index, newValue) => {
    const updatedOriginList = cloneDeep(originList);
    updatedOriginList[index].name = newValue;
    setOriginList(updatedOriginList);
  }

  const resetName = () => {
    setOriginList(currentSmsConfigList);
  }

  const saveName = async (index) => {
    try {
      const response = await controller.saveName(selectedOrg.id, originList[index]);

      if (response.error) {
        throw response.error;
      }

      successCallback();
    } catch (error) {
      errorCallback(error);
    }
  }

  // Side effect
  useEffect(() => {
    setOriginList(currentSmsConfigList);
  }, [currentSmsConfigList]);

  return (
    <Table responsive striped hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>#</th>
          {tableHeader()}
          <th>
            {t('06df33001c')}
          </th>
        </tr>
      </thead>
      <tbody>
        {currentSmsConfigList.length === originList.length && currentSmsConfigList.map((smsConfig, index) => {
          return (
            <tr key={index}>
              <td>{((selectedPage - 1) * selectedPageLimit) + index + 1}</td>
              <td>
                <EditableNameBox
                  containerClassName={smsConfigurationStyle['table-editableNameBox']}
                  onClickCancelIcon={resetName}
                  inputFieldOnKeyDown={e => saveName(index)}
                  inputFieldOnChange={e => changeName(index, e.target.value)}
                  value={originList[index].name}
                />
              </td>
              <td>{showAccessLevel(smsConfig)}</td>
              <td>{smsConfig.twilioAccountSid}</td>
              <td>{smsConfig.twilioFromNumber}</td>
              <td>{smsConfig.resendAfter} {t('26fba427f3')}</td>
              <td>{smsConfig.maximumResend} {t('490f603521')}</td>
              <td>{smsConfig.maximumRequest} {t('490f603521')}</td>
              <td>{smsConfig.denialPeriod} {t('26fba427f3')}</td>
              <td>{smsConfig.OtpExpiresIn} {t('26fba427f3')}</td>
              <td>{smsConfig.allowedPhonePrefix}</td>
              <td className={'table-action-td'}>
                <ButtonAction
                  label="7e77616685"
                  title="7e77616685"
                  iconClassName="icon-edit"
                  onClick={() => {
                    selectSmsConfigCallback(smsConfig);
                    changeModalStatus(modalStatus.addOrEdit.type, true);
                  }}
                />
                <ButtonAction
                  label="ce64bbe3ba"
                  title="ce64bbe3ba"
                  iconClassName="icon-trash"
                  onClick={() => {
                    handleDelete(smsConfig.id);
                    changeModalStatus(modalStatus.delete.type, true);
                  }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default SmsConfigurationTable;
